import { PageHeader } from "@/pages/Categories";
import { Link } from "react-router-dom";
import { ArrowUpRight, Search, Users, Factory, FlaskConical, Handshake, FileText, Ship, MailPlus, ClipboardCheck } from "lucide-react";

const SERVICES = [
  { icon: Search, t: "Product sourcing from India", d: "End-to-end sourcing of non-perishable goods, components, ingredients and branded products from India's manufacturing clusters." },
  { icon: Users, t: "Supplier shortlisting", d: "Filtered shortlist of 3–6 suppliers per brief, scored on capability, capacity, compliance and commercial fit." },
  { icon: Factory, t: "Factory verification coordination", d: "We coordinate factory audits, document verification and on-the-ground checks tailored to the category." },
  { icon: FlaskConical, t: "Sample coordination", d: "Sample requests, courier, feedback loops and revision rounds — managed centrally with one point of contact." },
  { icon: Handshake, t: "Price negotiation", d: "Transparent commercial negotiation: FOB / CIF / DAP, payment milestones, tooling, MOQs and volume tiers." },
  { icon: FileText, t: "Documentation support", d: "COA, SDS, IFRA (where relevant), product specs, packing lists, COO and export paperwork coordinated case by case." },
  { icon: Ship, t: "Export & logistics coordination", d: "FCL / LCL planning, port routing, freight forwarder coordination and shipment tracking through to delivery." },
  { icon: MailPlus, t: "Buyer–supplier introduction", d: "Where you prefer direct, we set up qualified introductions with clean handover packs and continuity support." },
  { icon: ClipboardCheck, t: "Ongoing account management", d: "Repeat orders, supplier reviews, QC follow-through and continuous improvement on price, lead-time and quality." },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="SERVICES"
        title="A complete sourcing operations layer."
        sub="From first brief to repeat orders, VYR Trade is the single accountable interface to your Indian supply chain."
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {SERVICES.map((s, i) => (
            <div key={s.t} className="border border-white/5 bg-zinc-900/40 rounded-lg p-6 hover:border-white/15 transition-colors" data-testid={`svc-${i}`}>
              <div className="flex items-center justify-between">
                <div className="h-9 w-9 rounded-md border border-white/10 grid place-items-center bg-zinc-950">
                  <s.icon className="h-4 w-4 text-amber-400" />
                </div>
                <div className="font-mono text-[10px] tracking-[0.22em] text-zinc-500">SVC.{String(i + 1).padStart(2, "0")}</div>
              </div>
              <div className="mt-5 font-display text-[18px] font-semibold leading-tight">{s.t}</div>
              <p className="mt-2 text-[13.5px] text-zinc-400 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 border border-white/10 bg-zinc-950 rounded-lg p-8 sm:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="font-mono text-[11px] tracking-[0.22em] text-amber-400">TRUST & DISCLOSURE</div>
            <h3 className="mt-2 font-display text-2xl font-semibold">A sourcing & trade facilitation company.</h3>
            <p className="mt-2 text-zinc-400 text-[14px] leading-relaxed">
              VYR Trade is a sourcing and trade facilitation company — not a manufacturer, unless explicitly stated.
              Supplier verification, certificates, samples and compliance documents are coordinated case by case.
              Documentation we can help coordinate: COA, SDS, IFRA (where relevant), product specifications, packing lists, export documents.
            </p>
          </div>
          <Link to="/quote" className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-blue-600 hover:bg-blue-500 text-white font-medium text-sm" data-testid="svc-cta-quote">
            Start a brief <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
